import React from 'react';
import { round2 } from '../../lib/format';
import { ScoreCard } from './ScoreCard';

export const Scores = ({ totals }) => (
  <div className="s-lineup-explorer__data-container">
    <h3 className="s-lineup-explorer__metrics-header">Metrics - All Lineups</h3>
    <div className="s-lineup-explorer__scores-container">
      <div className="s-lineup-explorer__score">
        <ScoreCard
          title="Playing Time"
          value={Math.round(totals.total_minutes)}
          color="#417505"
        />
      </div>

      <div className="s-lineup-explorer__score">
        <ScoreCard
          title="Possession Total"
          value={Math.round(totals.total_possessions)}
          color="#417505"
        />
      </div>

      <div className="s-lineup-explorer__score s-lineup-explorer__score--double">
        <ScoreCard title="Scored" value={totals.total_points} color="#3F668D" />
        <ScoreCard
          title="Allowed"
          value={totals.total_points_allowed}
          color="#7F50A8"
        />
      </div>

      <div className="s-lineup-explorer__score">
        <ScoreCard
          title="Total Plus-Minus"
          value={round2(totals.total_plus_minus)}
          color="#417505"
        />
      </div>

      <div className="s-lineup-explorer__score">
        <ScoreCard
          title="Net Rating"
          value={round2(totals.total_factored_net_rating)}
          color="#417505"
        />
      </div>

      <div className="s-lineup-explorer__score s-lineup-explorer__score--double">
        <ScoreCard
          title={`Scored Per ${totals.factor} Pos`}
          value={round2(totals.total_factored_points_poss)}
          color="#3F668D"
        />
        <ScoreCard
          title={`Allowed Per ${totals.factor} Pos`}
          value={round2(totals.total_factored_opp_points_poss)}
          color="#7F50A8"
        />
      </div>
    </div>
  </div>
);
